import * as React from "react";

import { TopicData } from "@/shared/state/visualization";

/**
 * Returns a function that checks if a given TopicData is a duplicate
 * of an existing column in the log panel.
 */
export function useIsDuplicateColumn(columns: TopicData[]) {
  return React.useMemo(
    () => (nextTopicData: TopicData) => {
      const existingIds = columns.map((data) => data.messagePath.id);
      return existingIds.includes(nextTopicData.messagePath.id);
    },
    [columns],
  );
}
